module.exports = __webpack_public_path__ + "static/media/banner_low.45b40cf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/components/imgs/banner_low.jpg
// module id = 1285
// module chunks = 0